import React, { createContext, useContext, useEffect, useState } from 'react';
import { Category } from '../data/types';
import { toolCategories as staticToolCategories } from '../data/toolsByCategory';

interface ToolContextProps {
  toolCategories: Category[];
  loading: boolean;
}

const ToolContext = createContext<ToolContextProps>({
  toolCategories: [],
  loading: true,
});

export const ToolProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [toolCategories, setToolCategories] = useState<Category[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Directly use local static data instead of fetching
    setToolCategories(staticToolCategories);
    setLoading(false);
  }, []);

  return (
    <ToolContext.Provider value={{ toolCategories, loading }}>
      {children}
    </ToolContext.Provider>
  );
};

export const useTools = () => useContext(ToolContext);
